<template>
	<div id="app" ref="app">
		<div id="nav">
			<tpheader v-if="$route.meta.showHeader" ref="tpheader" :titleText="$route.meta.titleText"></tpheader>
		</div>
		<router-view />
		<tpfooter v-if="$route.meta.showFooter" ref="tpfooter"></tpfooter>
	</div>
</template>

<script>
import router from "./router.js";
// import { constants } from 'crypto';
export default {
	created: function() {
		
		
		// // 线上 start
		// let url = "";
		// let hostName = window.location.hostname;
		// // 指向人才
		// let belongToZZRC = `
  //           jxjy.zzrc.cn,    
		//     http://zzrc-uat.ca163.net.cn,
		//     http://zzrc.ca163.net,
		//     https://zzrc.ca163.net,
  //           zzrc-uat.ca163.com`;
		// if (belongToZZRC.includes(hostName)) {
		// 	url = "http://zzrc.ca163.net";
		// } else {
		// 	url = window.location.origin;
		// }
		// // 指向畅和
		// let belongToZZCH = `zzch-uat.ca163.net.cn,
  //           zzch.ca163.net,
  //           zzch-uat.ca163.com
  //           http://jxjy.zzzjedu.com`;
		// if (belongToZZCH.includes(hostName)) {
		// 	url = "http://zzch-test.ca163.net";
		// } else {
		// 	url = window.location.origin;
		// }
		// // 线上 end

		// 本地测试
		let url = this.testUrl;//

		//在页面加载时读取sessionStorage里的状态信息
		if (sessionStorage.getItem("allstore")) {
			this.$store.replaceState(
				Object.assign(
					{},
					this.$store.state,
					JSON.parse(sessionStorage.getItem("allstore"))
				)
			);
		}

		//在页面刷新时将vuex里的信息保存到sessionStorage里
		window.addEventListener("beforeunload", () => {
			sessionStorage.setItem(
				"allstore",
				JSON.stringify(this.$store.state)
			);
		});

		// 从浏览器缓存中取店铺数据，如果有数据，则不需要再发请求
		let shop = sessionStorage.getItem("store");
		if (this.$isAbnormal(shop)) {
			this.$post("shops/get", { url: url }).then(res => {
				this.$store.state.store = res.data.result;
				sessionStorage.setItem(
					"store",
					JSON.stringify(this.$store.state.store)
				);
			});
		} else {
			this.$store.state.store = shop;
		}

		// 将辅导员的token从浏览器缓存中取出
		this.$store.state.instructor = sessionStorage.getItem("instructor");

		// 将店铺的信息从浏览器缓存中取出并转成对象存储在vuex
		this.$store.state.store = JSON.parse(sessionStorage.getItem("store"));

		// 如果用户token为空且浏览器缓存中存有tpid则进入
		if (!this.$store.state.id && sessionStorage.getItem("tpid")) {
			// 从浏览器缓存中获取tpid并赋值到用户token
			this.$store.state.id = sessionStorage.getItem("tpid");

			// 从浏览器缓存中获取tpname并赋值到用户姓名
			this.$store.state.name = sessionStorage.getItem("tpname");

			// 从浏览器缓存中获取tpuserId并赋值到用户userId
			this.$store.state.userId = sessionStorage.getItem("tpuserId");

			// 从浏览器缓存中获取tpshopid并赋值到店铺id
			this.$store.state.shopId = sessionStorage.getItem("tpshopid");
		}
	},
	mounted: function() {
		if (this.$store.state.id) {
			this.$post("shopping_cart/search", {
				token: this.$store.state.id,
				offset: "0",
				length: 9999
			}).then(res => {
				this.$store.state.shopNum = res.data.result.data.length;
			});
		}
	}
};
</script>

<style>
/* @import "./common/font/font.css"; */
#app {
	/*保证footer是相对于container位置绝对定位*/
	position: relative;
	width: 100%;
	min-height: 100%;
	/*设置padding-bottom值大于等于footer的height值，以保证main的内容能够全部显示出来而不被footer遮盖；*/
	padding-bottom: 150px;
	box-sizing: border-box;
}
html,
body {
	height: 100%;
}
.hand {
	cursor: pointer;
}
html,
body,
div,
span,
ul,
li,
a,
input,
html,
body,
button {
	margin: 0;
	padding: 0;
}
#app {
	min-width: 1280px;
	width: expression(document.body.clientWidth < 1280? "1280px": "auto");
}
</style>
